import React from 'react';
import { isValidPhoneNumber } from 'react-phone-number-input';
import PhoneInputWithCountry from 'react-phone-number-input/react-hook-form';
import { getCookie } from '@services/cookies';
import { formatPhoneErrorMessage } from '@services/format';
import { COOKIES } from '@constants/cookies';
import 'react-phone-number-input/style.css';
import styles from '../custom-input/custom-input.module.scss';

interface IProps {
  id: string;
  autoComplete: string;
  control: any;
  countryCallingCodeEditable?: boolean;
  error?: any;
  required?: boolean;
  showLabel?: boolean;
  shouldValidate?: boolean;
  hasValue?: boolean;
}

const PhoneNumberInput: React.FC<IProps> = ({
  id,
  autoComplete = 'on',
  control,
  countryCallingCodeEditable = false,
  error,
  required = false,
  showLabel = true,
  hasValue,
}) => {
  const defaultCountry = getCookie(COOKIES.userCountry) || 'GB';

  const errorMessage = error && formatPhoneErrorMessage(error);

  return (
    <>
      <div className={!error ? styles.phoneInputContainer : styles.phoneInputErrorContainer}>
        <PhoneInputWithCountry
          type="tel"
          id={id}
          name={id}
          control={control}
          rules={{
            required,
            validate: hasValue && isValidPhoneNumber,
          }}
          className={styles.phoneInput}
          autoComplete={autoComplete}
          international={true}
          countryCallingCodeEditable={countryCallingCodeEditable}
          defaultCountry={defaultCountry}
        />
        {showLabel && (
          <label htmlFor={id} className={styles.phoneInputPlaceholder}>
            Phone
          </label>
        )}
        {errorMessage && <small className={styles.phoneInputError}>{errorMessage}</small>}
      </div>
    </>
  );
};
export default PhoneNumberInput;
